<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('detailAudit.dispositif.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-6">
          <div class="columns">
            <div class="column is-4">
              <div v-if="audit.otPatrimoine.otsAuditEnfants.length > 0">
                <div class="field has-addons">
                  <div class="control inputSearch has-icons-left is-clearfix">
                    <b-input :placeholder="$t('detailAudit.dispositif.actions.search')"
                             v-model="search" type="search">
                    </b-input>
                    <b-icon class="icon is-left"
                            icon="magnify"></b-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered has-background-background pdt-20px pdb-20px"
           v-if="audit.otPatrimoine.otsAuditEnfants.length === 0">
        <h1 class="title is-size-4">
          {{ $t('detailAudit.dispositif.aucunDispositif')}}
        </h1>
      </div>
      <div v-else-if="filteredEmplacement.length > 0">
        <ligne-emplacement :emplacement="emplacement"
                           :afficherAffectation="false"
                           :index="index"
                           :afficherCheckbox="false"
                           :afficherCheckboxMateriel="false"
                           :afficherCheckboxFace="false"
                           v-for="(emplacement, index) in filteredEmplacement" :key="index">
        </ligne-emplacement>
        <scrollLoader :loader-method="addEmplacementToLoad" :loader-disable="loaderStatus
      || filteredEmplacement.length < currrentPageSize"
                      :loader-distance="400" :loader-size="50">
        </scrollLoader>
      </div>
      <div class="has-text-centered has-background-background pdt-20px pdb-20px"
           v-else>
        <h1 class="title is-size-4">
          {{ $t('general.autocomplete.noRslt')}}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>

import ligneEmplacement from '@/components/gabed/general/ligneEmplacement';
import scrollLoader from '@/components/general/scrollLoader';
import {
  getEmplacementDispositifMaterielAndFaceFromListeDispositif,
} from '@/services/logistique/audit/getEmplacementDispositifMaterielFaceFromListDispositif';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import filtrePatrimoineEmplacementSansMaterielDemonte from '@/services/logistique/audit/filtrePatrimoineSansDemonte';

export default {
  name: 'LogistiqueAuditDetailPatrimoine',
  props: {
    audit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      loaderStatus: false,
      currrentPageSize: 20,
      rangeToAddAfterEndOfScroll: 5,
      emplacements: [],
    };
  },
  components: {
    ligneEmplacement,
    scrollLoader,
  },
  computed: {
    filteredEmplacement() {
      return this.emplacements.filter((emplacement) => {
        const dispositif = emplacement.dispositifs.filter((dispositif) => {
          return dispositif.code
            && dispositif.code.toLowerCase().includes(this.search.toLowerCase());
        });
        return dispositif.length > 0;
      }).slice(0, this.currrentPageSize);
    },
  },
  methods: {
    addEmplacementToLoad() {
      if (this.currrentPageSize >= this.emplacements.length) {
        this.loaderStatus = true;
        this.currrentPageSize = this.emplacements.length;
        return;
      }
      this.currrentPageSize += this.rangeToAddAfterEndOfScroll;
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const emplacement = getEmplacementDispositifMaterielAndFaceFromListeDispositif(
        cloneDeep(this.audit.otPatrimoine.otsAuditEnfants.map((ot) => ot.otPatrimoine.dispositif)),
      );
      this.emplacements = filtrePatrimoineEmplacementSansMaterielDemonte(emplacement);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
